(function($){
  'use strict';
  //only for long doc page now
  if ($('.long-document').length > 0 && $('.back-to-top__wrapper').length > 0) {
    var $wrpBTT = $('.back-to-top__wrapper');
    var $btnBTT = $('.back-to-top__anchor');

    $btnBTT.on('click', function(e) {
      e.preventDefault();

      $('body, html').animate({
          scrollTop: $($(this).attr('href')).offset().top - 40
      }, 1000);
    });


    $(document).scroll(function () {
      var position_top = $('.section__column--right').offset().top;
      var body_top = $(window).scrollTop();
      var footer_off = $('.footer').offset().top;
      var footer_calc = footer_off - body_top;
      var windowHeight = $(window).height();

      if (position_top <= body_top) {
        $wrpBTT.fadeIn();
      } else {
        $wrpBTT.fadeOut();
      }

      if (footer_calc <= windowHeight) {
        $wrpBTT.css('position', 'static');
        $wrpBTT.css('bottom', '0');
      } else {
        $wrpBTT.css('position', 'fixed');
        $wrpBTT.css('bottom', '20px');
      }
    });
  }
}(jQuery));